<div class="bg-blue-gradient p-3 rounded-10">
  <div class="text-center mb-2 py-2">
    <!-- <img
      src="../../../../assets/img/kingpin-logo-white.png"
      alt="Logo"
      width="150"
      class="img-fluid mb-3"
    /> -->
    <h4 class="text-white fw-bold">PRO SPORTS PICKS</h4>
    <h5 class="text-light fw-bold">SUBSCRIPTION</h5>
  </div>
  <div class="subscription-slider">
    <app-subscription-features-slider
      *ngIf="!Popup"
    ></app-subscription-features-slider>
  </div>
</div>
<div class="container">
  <div class="row justify-content-center subscription-plan-container mb-5" *ngIf="!(_user.subscribed | async)">
    <div
      [ngClass]="{ 'col-md-4 col-lg-3': !Popup, 'col-md-6 col-lg-5': Popup }"
      class="mb-2"
    >
      <div
        class="bg-white rounded-10 shadow px-3 py-4 subscription-plan text-center"
      >
        <!-- <img
          src="../../../../assets/img/subscription_design.png"
          alt="subscription"
          class="img-fluid subscription-plan-img"
        /> -->
        <h5 class="fw-bolder text-muted">Monthly</h5>
        <h3 class="fw-bolder text-blue">7-Day Free Trial</h3>
        <h3 class="fw-bold mb-4 text-muted" id="price_monthly_29"><small style="font-size: 13px;">and then</small> $29.99</h3>
        <h3 class="fw-bold mb-4 text-muted" style="display: none;" id="price_monthly_19"><small style="font-size: 13px;">and then</small> $19.99</h3>
        <h3 class="fw-bold mb-4 text-muted" style="display: none;" id="price_monthly_9"><small style="font-size: 13px;">and then</small> $9.99</h3>
        <h3 class="fw-bold mb-4 text-muted" style="display: none;" id="price_monthly_4"><small style="font-size: 13px;">and then</small> $4.99</h3>
        <div class="small border-bottom border-light mb-3" id="plan_description">
          Billed monthly<br>
        </div>
        <!-- $29.99 month with trial -->
        <button
          type="button"
          class="btn btn-theme px-4 px-md-5 m-auto"
          id="price_29"
          gaEvent="subscribe"
          gaCategory="monthly 29.99$"
          (click)="postData('price_1L6qogJVhyekqdlieOigWywC',7)"
        >
          Get Kingpin PRO
        </button>
        <!-- $19.99 month with trial -->
        <button
          type="button"
          id="price_19"
          class="btn btn-theme px-4 px-md-5 m-auto"
          style="display: none;"
          gaEvent="subscribe"
          gaCategory="monthly 19.99$"
          (click)="postData('price_1L9V9KJVhyekqdliZN98YPY3',7)"
        >
          Get Kingpin PRO
        </button>
        <!-- $9.99 month with trial -->
        <button
          type="button"
          id="price_9"
          class="btn btn-theme px-4 px-md-5 m-auto"
          gaEvent="subscribe"
          gaCategory="monthly 9.99$"
	  style="display: none;"
          (click)="postData('price_1L9VDUJVhyekqdlipUxvfMS1',7)"
        >
          Get Kingpin PRO
        </button>
        <!-- $4.99 month with trial -->
        <button
          type="button"
          id="price_4"
          class="btn btn-theme px-4 px-md-5 m-auto"
          style="display: none;"
          gaEvent="subscribe"
          gaCategory="monthly 4.99$"
          (click)="postData('price_1L9VIhJVhyekqdli46hVgXG7',7)"
        >
          Get Kingpin PRO
        </button>
      </div>
    </div>
    <div
      [ngClass]="{ 'col-md-4 col-lg-3': !Popup, 'col-md-6 col-lg-5': Popup }"
      class="mb-4"
    >
      <div
        class="bg-white rounded-10 shadow px-3 py-4 subscription-plan text-center"
      >
        <!-- <img
          src="../../../../assets/img/subscription_design.png"
          alt="subscription"
          class="img-fluid subscription-plan-img"
        /> -->
        <h5 class="fw-bolder text-muted">Annual</h5>
        <h3 class="fw-bolder text-blue">$8.33</h3>
        <h5 class="fw-bold mb-4 text-muted">per month</h5>
        <div class="small border-bottom border-light mb-3">Billed annually</div>
        <button
          type="button"
          class="btn btn-theme px-4 px-md-5"
          (click)="postData('price_1KOFEoJVhyekqdliNsyxCtIc')"
          gaEvent="subscribe"
          gaCategory="annually"
        >
          Get Kingpin PRO
        </button>
        <!-- <button
          type="button"
          class="btn btn-theme px-4 px-md-5"
          data-bs-toggle="modal"
          data-bs-target="#appusemodal"
        >
          Get Kingpin PRO
        </button> -->
      </div>
    </div>
  </div>
  <div class="row">
    <!-- <div class="col-auto mx-auto mb-5">
      <button type="button" class="btn btn-theme px-4 px-md-5 py-2">
        Already purchased? Restore
      </button>
    </div> -->
    <div class="col-12 mb-4" [class.mb-4]="!Popup">
      <div class="bg-white p-3 rounded-10">
        <h4 class="fw-bolder mb-3 text-dark">What’s included?</h4>
        <div class="kingpin-table subscription-table">
          <div class="table-row header blue">
            <div class="cell text-dark"></div>
            <div class="cell text-dark text-center bg-light-blue w-lg-300">
              Regular
            </div>
            <div class="cell text-center bg-primary w-lg-300">Pro</div>
          </div>

          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Chance to win the monthly pot
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">Chat</div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Place picks
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Personal bet tracking and statistics
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Live odds
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Pick history from every expert
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Statistics from every expert
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/tick-green.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Sharp pick
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/cross-red.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Expert picks
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/cross-red.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Upcoming picks from every expert
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/cross-red.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Instant pick notifications
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/cross-red.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
          <div class="table-row">
            <div class="cell text-center text-md-start" data-title="">
              Track your experts
            </div>
            <div class="cell text-center bg-light-blue" data-title="Regular">
              <img src="../../../../assets/icons/cross-red.svg" alt="" />
            </div>
            <div class="cell fw-bold text-center bg-primary" data-title="Pro">
              <img src="../../../../assets/icons/tick-white.svg" alt="" />
            </div>
          </div>
        </div>
        <!-- table close -->
      </div>
    </div>
    <ng-container *ngIf="!Popup">
      <div class="col-6 mb-4">
        <a href="#">Privacy Policy</a>
      </div>
      <div class="col-6 mb-4">
        <a href="#">Terms & Conditions</a>
      </div>
      <div class="col-12">
        <p class="mb-3 small">
          You will automatically be billed the above amount through your iTunes
          Account upon confirmation of the purchase and thereafter every
          relevant period (each month or each year) until you cancel your
          subscription. Your subscription will automatically renew unless that
          automatic renewal option is turned off at least 24 hours before the
          end of the current period. Your account will be charged for renewal
          within 24 hours prior to the end of the current period in the same
          amount as you are subscribing for now. Daily passes do not renew
          automatically. Your subscription can be managed, and the auto-renewal
          may be turned off, by going to the iTunes Account Settings after
          purchase. Any unused portion of a yes period, if offered, will be
          forfeited when the user purchased a subscription to that publication,
          where applicable.
        </p>

        <h4 class="fw-bolder mb-3 text-dark">Disclamer</h4>

        <p class="mb-3 small">
          www.kingpin.pro L.L.C. (“Kingpin”) is not an online gambling operator
          or a gambling app of any kind.
        </p>
        <p class="mb-3 small">
          The materials on Kingpin’s app are provided on an ‘as is’ basis.
          Kingpin makes no warranties, expressed or implied, and hereby
          disclaims and negates all other warranties including, without
          limitation, implied warranties or conditions of merchantability,
          fitness for a particular purpose, or non-infringement of intellectual
          property or other violation of rights.
        </p>
        <p class="mb-3 small">
          Kingpin does not warrant or make any representations concerning the
          accuracy, likely results, or reliability of the use of the materials
          on its app or otherwise relating to such materials or on any sites
          linked to this app.
        </p>
        <p class="mb-3 small">
          Whilst we try to provide top advice and picks, we are not liable for
          any losses you may incur as a result of any sports betting or
          gambling.
        </p>
        <p class="mb-3 small">
          There are no guarantees with any type of gambling. All forms of
          financial trading, including sports betting, carry risk and it is down
          to the individual trader or company to make these bets with or without
          the information on the app. Past performances do not guarantee success
          in the future. Although certain of our experts have been profitable in
          the past, there are no certainties when it comes to betting, so only
          risk money that you can afford to lose.
        </p>
        <p class="mb-3 small">
          Where we provide links to third party websites, we will not be held
          responsible for any content published on these sites. Kingpin will not
          be liable to you in relation to the contents of, or use of, or
          otherwise in connection with, this app. While we are in the business
          of sports picks, it is your responsibility to be aware and know of the
          laws that apply to your area or country before conducting any kind of
          online gambling.
        </p>
        <p class="mb-3 small">
          By visiting our app, you confirm that you understand that it is
          possible to lose some or all monies used when betting on sports or
          doing any gambling. You cannot hold Kingpin responsible for any such
          losses.
        </p>
        <p class="mb-3 small">
          Please only gamble with funds that you can afford to lose.
        </p>
      </div>
    </ng-container>
  </div>
</div>

<!-- <div class="modal" tabindex="-1" id="login_modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-10 border-0">
      <div
        class="modal-header subscribe-modal-header px-0 pt-5 border-0 d-block"
      >
        <div class="subscribe-logo py-2 px-4 rounded-10 text-center">
          <img
            src="../assets/img/logo-full.png"
            alt="logo"
            class="img-fluid rounded"
            width="110"
          />
          <h3 class="mt-4 fw-bolder text-blue">SUBSCRIPTION</h3>
        </div>
        <button
          type="button"
          class="btn-close bg-white align-self-start"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body p-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style="width: 100%; height: 80px; transform: rotate(180deg)"
          viewBox="0 0 1500 500"
          preserveAspectRatio="none"
        >
          <path
            d="M 0,0
                   L 0,250
                   Q 750,500 1500,250
                   L 1500, 0
                   Z"
            fill="#daf9ea"
          />
        </svg>
        <div class="subscription-input-body p-3">
          <form [formGroup]="loginForm" autocomplete="off" class="py-2">
            <div class="mb-3 px-5">
              <ng-container *ngIf="loginForm.get('email') as control">
                <input
                  type="email"
                  class="form-control form-control-lg form-control"
                  [class.is-invalid]="control.touched && control.errors"
                  [formControl]="control"
                  placeholder="Your Email"
                  autocomplete="off"
                />
                <ng-container *ngIf="control.touched && control.errors">
                  <small
                    *ngIf="control.hasError('required')"
                    class="text-danger mb-2 errors-label"
                    >Please enter email address.</small
                  >
                  <small
                    *ngIf="control.hasError('email')"
                    class="text-danger mb-2 errors-label"
                    >Please enter valid email address.</small
                  >
                </ng-container>
              </ng-container>
            </div>
            <div class="mb-5 px-5">
              <ng-container *ngIf="loginForm.get('password') as control">
                <input
                  type="password"
                  class="form-control form-control-lg form-control"
                  [class.is-invalid]="control.touched && control.errors"
                  [formControl]="control"
                  placeholder="Password"
                  autocomplete="off"
                />
                <ng-container *ngIf="control.touched && control.errors">
                  <small
                    *ngIf="control.hasError('required')"
                    class="text-danger mb-2 errors-label"
                    >Please enter password.</small
                  >
                </ng-container>
              </ng-container>
            </div>
          </form>
          <div class="text-center pb-4">
            <button
              type="button"
              [disabled]="submitted"
              class="btn btn-theme px-5 btn-lg"
              (click)="postData()"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
